module.exports = __webpack_public_path__ + "static/media/Item_Armor_C_00_Lv3_C.7d50c454.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/item/Equipment/Vest/Item_Armor_C_00_Lv3_C.png
// module id = 371
// module chunks = 0